import React from 'react'
import { Button, Dialog as MUIDialog, CircularProgress } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { useTranslation } from 'react-i18next';
import { useStyles } from "../../orders/PartialRefund/styles"

interface IConfirmLocationChangeDialog {
  isOpen: boolean
  setIsOpen: (v: boolean) => void
  onConfirm: () => void
  isLoading: boolean
}

export default function ConfirmLocationChangeDialog(props: IConfirmLocationChangeDialog) {
  const {isOpen, setIsOpen, onConfirm, isLoading} = props;

  const classes = useStyles();

  const {t} = useTranslation()

  return (
    <MUIDialog
      open={isOpen}
      maxWidth={"md"}
      className={classes.ModalContainer}
      transitionDuration={300}
      data-component-name="dialog"
    >
      <>
        <header className={classes.ConfirmationModalHeader}>
          <div>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => setIsOpen(false)}
              aria-label="close"
              data-component-name="DialogCloseButton"
            >
              <CloseIcon />
            </IconButton>
          </div>
        </header>
        {isLoading ? <div style={{ margin: "6rem 10rem", display: "flex", alignItems: "center", justifyContent: "center" }}><CircularProgress /></div> : <div className={classes.ConfirmationModalBody}>
          <div className={classes.ConfirmationModalContent}>
            <p>{t('selectLocation.youAreChangingTheLocation')}</p>
          </div>
          <footer className={classes.ConfirmationModalFooter}>
            <Button
              style={{ padding: "0.9375rem 1.5625rem", backgroundColor: "#FEEEE0", marginLeft: "1.25rem", color: "#FA7800" }}
              variant={'contained'}
              onClick={onConfirm}
              data-component-name="CONFIRMATION_CONFIRM"
            >
              {t('PartialReafund.Buttons.Ok')}
            </Button>
          </footer>
        </div>}
      </>
    </MUIDialog>
  )
}
